import ExternalSign from "routes/ExternalSign/ExternalSign";
import reservationRouter from "./reservationRouter";

const externalSignRouter = [
    {
        path: "external_sign",
        element: <ExternalSign />,
        children: [...reservationRouter],
    },
];

export default externalSignRouter;
